<template>
  <div>
    <Message :type="message.type" :title="message.title" :content="message.content" :show.sync="message.show" />
    <Banner
      :showForm="!showScrollForm"
      :video="banner.video"
      :list="banner.list"
      @msg="handleShowMsg"
      :landingPageName="landingPageName"
      @setShowSuccessDialog="setShowSuccessDialog"
    />
    <PainPoints
      :title="painPoints.title"
      :leftTitle="painPoints.leftTitle"
      :rightTitle="painPoints.rightTitle"
      :leftList="painPoints.leftList"
      :rightList="painPoints.rightList"
    />
    <ImgTabs :title="imgTabs.title" :tabs="imgTabs.tabs" />
    <LowCostAccess :title="lowCostAccess.title" :list="lowCostAccess.list" />
    <LawText />
    <Reason :title="reason.title" :imgs="reason.imgs" :url="reason.url" :centerImg="reason.centerImg" />
    <Ecology :title="energy.title" :list="energy.list" />
    <OrgList :title="orgList.title" :list="orgList.list" />
    <Footer />
    <!-- 左侧计算机小象 -->
    <LeftBar />
    <WeilingSuccessDialog :wlCode="true" v-if="showSuccessDialog" @closeform="showSuccessDialog = false" />
  </div>
</template>

<script>
import pageMixin from './pageMixin.js'
const pubStr = window.location.search && window.location.search.match(/tsign_source_detail=[^&]+/)
const pub = pubStr && pubStr.length && pubStr[0].split('=')[1]

export default {
  mixins: [pageMixin],
  components: {
    LeftBar: () => import('@/components/LeftBar/index.vue'),
    // ModifyHeader: () => import('./components/pc/ModifyHeader.vue'),
    Banner: () => import('./components/pc/Banner.vue'),
    // Contact: () => import('./components/pc/Contact.vue'),
    Ecology: () => import('./components/pc/Ecology.vue'),
    Footer: () => import('./components/pc/Footer.vue'),
    ImgTabs: () => import('./components/pc/ImgTabs.vue'),
    LawText: () => import('./components/pc/LawText.vue'),
    LowCostAccess: () => import('./components/pc/LowCostAccess.vue'),
    Message: () => import('./components/pc/Message.vue'),
    OrgList: () => import('./components/pc/OrgList.vue'),
    PainPoints: () => import('./components/pc/PainPoints.vue'),
    Reason: () => import('./components/pc/Reason.vue'),
    WeilingSuccessDialog: () => import('@/components/saasApiSuccessForm.vue'),
    // Header: () => import('./components/pc/Header.vue'),
  },
  data() {
    return {
      showSuccessDialog: false,
      // 落地页名字'e签宝宣传'，因为以上的组件会被多次复用，为了服务商收集数据的时候能够更准确，用这个名字去判断是否需要向服务商发送数据
      landingPageName: 'esignPropagate',
      banner: {
        video: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanre/banner.mp4',
        list: [
          ['19年', '服务经验'],
          ['502万', '企业用户'],
          ['2.7亿', '个人用户'],
          ['121亿', '总签章量'],
          ['24x365小时', '管家式服务'],
        ],
      },
      showScrollForm: false,
      imgTabs: {
        title: '电子签名应用场景（举例）',
        tabs: [
          {
            title: '企业内部人力资源应用',
            items: [
              {
                text: '劳动合同新签、续签',
                img: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/con2_bg1.png',
              },
              {
                text: '竞业协议/保密协议',
                img: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/con2_bg2.png',
              },
              {
                text: '期权授予协议',
                img: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/con2_bg3.png',
              },
              {
                text: '各类人力资源证明材料',
                img: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/con2_bg4.png',
              },
            ],
          },
          {
            title: 'B2B电商平台',
            items: [
              {
                text: '商家入驻协议',
                img: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/common/con1_bg1.png',
              },
              {
                text: '采购/销售协议',
                img: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/common/con1_bg2.png',
              },
              {
                text: '报价单',
                img: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/common/con1_bg3.png',
              },
              {
                text: '供应链融资协议',
                img: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/common/con1_bg4.png',
              },
            ],
          },
        ],
      },
      orgList: {
        title: '502万+企业用户的选择',
        list: [
          { title: '阿里巴巴', img: 'alibaba.jpg' },
          { title: '百度', img: 'baidu.jpg' },
          { title: '华为', img: 'huawei.jpg' },
          { title: '丰田', img: 'toyota.png' },
          { title: '索尼', img: 'sony.png' },
          { title: '建设银行', img: 'zhongguojianshe.png' },
          { title: '华夏银行', img: 'huaxiayinhang.png' },
          { title: '中国邮政储蓄银行', img: 'youzheng.png' },
          { title: '恒大集团', img: 'hengda.png' },
          { title: '绿城集团', img: 'lvcheng.png' },
          { title: '蚂蚁金服', img: 'mayijinfu.png' },
          { title: '钉钉', img: 'dingding.jpg' },
          { title: '网易', img: 'wangyi.png' },
          { title: '海康威视', img: 'haikangweishi.png' },
          { title: '德邦快递', img: 'debang.jpg' },
          { title: '中智', img: 'zhongzhi.jpg' },
          { title: '拉勾网', img: 'lagou.jpg' },
          { title: '蚂蜂窝', img: 'mafengwo.jpeg' },
        ].map((item) => {
          return {
            title: item.title,
            img: `https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/logos/${item.img}`,
          }
        }),
      },
      reason: {
        title: '为什么选择e签宝电子签名产品？',
        imgs: new Array(6)
          .fill('')
          .map((img, index) => `https://asset.esign.cn/apps/esign-landing/html/static/imgs/reason/reason${index}.png`),
        centerImg: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/center.png',
        url: `https://h5.esign.cn/usercenterFront/regist?pub=${pub}`,
      },
      painPoints: {
        title: '传统签署的痛点',
        leftTitle: '企业问题',
        rightTitle: '解决方案',
        leftList: [
          {
            title: '合同签署成本高',
            desc: '纸质合同线下签署的方式，带来了高昂的纸张成本、打印成本、异地签署的快递成本等',
          },
          {
            title: '纸质合同效率低',
            desc: '异地合同签署都要经历内部审批，来回快递等流程，平均每份合同要耗时3-10天，周期长效率低，严重影响业务进度',
          },
          {
            title: '纸质合同管理难',
            desc: '海量纸质合同的管理，已经成为困扰各类企业的普遍难题，合同管理环境要求高，并且查找困难，容易丢失',
          },
          {
            title: '潜在签约风险大',
            desc: '线下签署无法验证签署人身份真实性，盗用、私刻公章和篡改合同频发，存在较大假冒代签的风险',
          },
        ],
        rightList: [
          {
            title: '合同签署费用直降60%',
            subTitle: '第三方平台无纸化储存，系统随时调取；无需邮寄，全程线上完成',
          },
          {
            title: '电子签约，只须3秒',
            subTitle: '实时追踪合同状态，秒发秒签；随时随地调用查阅',
          },
          {
            title: '电子合同，轻松管理',
            subTitle: '区块存储，永久保存。多状态检索、查看、下载合同。',
          },
          {
            title: '用户身份绝无冒充，大大降低法律风险',
            subTitle: '人脸活体识别比对，公安人口库校验；拥有完整证据链；信息加密，点对点签署',
          },
        ].map((item, index) => {
          const imgSrcBase = 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/'

          return {
            ...item,
            img: `${imgSrcBase}tab_con${index}.png`,
          }
        }),
      },
      lowCostAccess: {
        title: 'e签宝电子签名服务已实现超低成本接入',
        list: [
          {
            menuTitle: '企业业务部门',
            mainTitle: '电子签名SaaS服务标准版',
            desc: '借助于e签宝SaaS服务成熟的功能体系，完成从合同起草到签约流程发起、通知发送、完成签署、合同管理的闭环服务。',
            img: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/con2tab2_bg1.png',
            url: `https://h5.esign.cn/usercenterFront/regist?pub=${pub}`,
          },
          {
            menuTitle: '对接企业OA、ERP等系统',
            mainTitle: '电子签名SaaS服务专业版',
            desc: '对于需要将合同签署流程与业务平台、内部系统集成的客户，e签宝提供电子签名SaaS服务专业版，开放API接口供客户系统集成，数行代码完成对接开发。',
            img: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/con2tab2_bg2.png',
            url: `https://h5.esign.cn/usercenterFront/regist?pub=${pub}`,
          },
          {
            menuTitle: '其它终端用户',
            mainTitle: 'Web、H5、微信小程序等终端',
            desc: 'e签宝支持与WEB、APP、H5、微信/支付宝小程序等多个终端快速集成，电商平台的终端用户们，可以0门槛使用e签宝电子签名服务。',
            img: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/common/con2tab2_bg3.png',
            url: `https://h5.dingtalk.com/open-market/share.html?shareGoodsCode=AADDC36E1A648100DE32B90C8ACCCF7F720304142ACB1D5623992C18A8A448F564DB2C60CA1DEAE6&token=5e348cf073e3d73642a728c86d5c1957&shareUid=678A35271A441235&pub=${pub}`,
          },
        ],
      },
      energy: {
        title: 'e签宝提供全生态电子签名服务',
        list: [
          {
            title: '电子签名',
            desc: '全程电子化签署，文件在线流转，极大提高文书签署效率',
            img: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/dz.png',
            imgSize: '59px 54px',
            hoverImg: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/dz-act.png',
          },
          {
            title: '合同管理',
            desc: '合同文件电子化存储，标签分类提升管理效率，一键搜索所见即所得',
            img: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/qm.png',
            imgSize: '65px 53px',
            hoverImg: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/qm-act.png',
          },
          {
            title: '存证保全',
            desc: '电子签名全过程数据存证，证据链条完整可靠，联合蚂蚁区块链，打造行业首个区块链电子劳动合同存证平台',
            img: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/cz.png',
            imgSize: '41px 54px',
            hoverImg: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/cz-act.png',
          },
          {
            title: '法律服务',
            desc: '联合公证处、司法鉴定中心、仲裁委，整合遍布全国的线下律师服务，打造安全无忧的司法保障服务体系',
            img: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/ty.png',
            imgSize: '64px 54px',
            hoverImg: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/ty-act.png',
          },
        ],
      },
      message: {
        type: '',
        title: '',
        content: '',
        show: false,
      },
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollHandle, true)
  },
  methods: {
    showDialog() {
      this.$refs.dialog.showDialog()
    },
    scrollHandle() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
      this.showScrollForm = scrollTop >= window.screen.height
    },
    handleShowMsg({ type, title, content }) {
      this.message.type = type
      this.message.title = title
      this.message.content = content
      this.message.show = true
    },
    setShowSuccessDialog(v) {
      this.showSuccessDialog = v
    },
  },
}
</script>

<style lang="less">
* > img {
  max-width: 100%;
}

a {
  font-size: 1rem;
  color: #333;
}

a:hover,
input.error {
  color: #fa465a;
}

.container {
  width: 1200px\9;
}

@media (min-width: 1200px) {
  .main {
    min-width: 1200px;
  }
}

.banner,
.banner video,
.banner .text,
.banner .text .banner_tabbox .tab_listbox,
.con,
.con1,
.con1 .con1_tab .tab_box,
.con2,
.con2 .con2_tab .tab_box,
.con3,
.con4,
.con6,
.footer {
  min-width: 1200px;
}

.btn {
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;
}
</style>
